<template>
  <div>
    <v-container container--fluid grid-list-xl>
       <v-row justify="center" align="center">
        <v-col cols="6" class="text-center align-center">
          <v-icon x-large color="green">fas fa-check-circle</v-icon>
          <h3>Your manifest has been uploaded successfully </h3>
          <h4>(Here is a summary of the lines that have been processed)</h4>
        </v-col>

        <v-col>
          <v-card class="elevation-2">
            <v-card-title>
             <h2 class="mr-2">Processed Lines</h2>

              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-btn icon size="35" color="green" v-on="on" @click="csvExport">
                    <v-icon color="green">cloud_download</v-icon>
                  </v-btn>
                </template>
                <span>Export CSV</span>
              </v-tooltip>

            </v-card-title>
            <v-divider></v-divider>
            <v-data-table
              v-if="results"
              :headers="headers"
              :items="results"
              :items-per-page="25"
            >
              <template v-slot:item="props">
                <tr>
                  <td style="text-align: center" @click="displayInfo(props.item)">{{ props.item.invoice}}</td>
                  <td style="text-align: center">{{ props.item.date}}</td>
                  <td class="text-center">{{ props.item.name}}</td>
                  <td style="text-align: center">{{ props.item.street1}}</td>
                  <td style="text-align: center">{{ props.item.suburb}}</td>
                  <td style="text-align: center">{{ props.item.state}}</td>
                  <td style="text-align: center">{{ props.item.postcode}}</td>
                  <td style="text-align: center">{{ props.item.phone1}}</td>
                  <td style="text-align: center">{{ props.item.tracking}}</td>
                  <td style="text-align: center">
                    <a :href="'trk.bcrc.io/' + props.item.tracking">
                      trk.bcrc.io/{{props.item.tracking}}
                    </a>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
       </v-row>

       <v-row class="mt-8 mb-4">
         <v-btn text block color="blue darken-1" @click="$router.go()">Next Manifest</v-btn>
        <v-btn text block color="blue darken-1" @click="$router.push('/manifest')">Done</v-btn>
       </v-row>
    </v-container>
  </div>
</template>

<script>
  // @vuese
  //
  // @group Manifest
  export default {
    name: "ManifestSummary",
    props: {
      results: Array,

    },
    data() {
      return {
        headers: [
          {text: 'Invoice No', value: 'invoice', align: 'center', sortable: true, width: '10%'},
          {text: 'Date', value: 'date', align: 'center', sortable: false, width: '10%'},
          {text: 'Name', value: 'name', align: 'center', sortable: false, width: '10%'},
          {text: 'Address', value: 'street1', align: 'center', sortable: false, width: '10%'},
          {text: 'Suburb', value: 'suburb', align: 'center', sortable: true, width: '10%'},
          {text: 'State', value: 'state', align: 'center', sortable: true, width: '10%'},
          {text: 'Postcode', value: 'postcode', align: 'center', sortable: false, width: '10%'},
          {text: 'Phone', value: 'phone1', align: 'center', sortable: false, width: '10%'},
          {text: 'Tracking Nº', value: 'tracking', align: 'center', sortable: false, width: '10%'},
          {text: 'Link to TrackPage', value: 'link', align: 'center', sortable: false, width: '10%'},
        ],
      }
    },
    methods: {
      // Exports all the processed lines (the approved ones) in a CSV file.
      csvExport() {
        let arrData = this.results;
        // Adding tracking_link column on csv
        arrData.map((row) => {
          row.tracking_link = 'trk.bcrc.io/' + row.tracking;
          return row
        });

        let csvContent = "data:text/csv;charset=utf-8,";
        csvContent += [
          Object.keys(arrData[0]).join(","),
          ...arrData.map(item =>
          { let row = Object.values(item).map((value) => {return '\"' + value + '\"'})
            return row.join(",")
          })
        ]
          .join("\n")
          .replace(/(^\[)|(\]$)/gm, "");

        const data = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", "manifest.csv");
        link.click();

      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Manifest/ManifestSummary.vue